export const smsTemplateVars = {
    customer: {
        name: "Summer"
    }  
}